import $ from "jquery";
import { debounce, getVh } from "../utils/functions";

const $window = $(window);
const $body = $("body");
const $pageBody = $(".page__body");
const $pageHeader = $(".page__header");
const $hamburger = $(".header__hamburger");
const $search = $(".search");
const $searchTrigger = $(".search__trigger");
const $searchWrapper = $(".search__wrapper");
const $searchClose = $(".search .search__close");
const $searchInput = $(".search .search__input");
const $searchContent = $(".search .search__content");
const $searchForm = $(".search .search__form");

const toggleSearch = (filter) => {
  if ($search.hasClass("active")) {
    hideSearch(filter, true);
  } else {
    showSearch();
  }
};

const showSearch = () => {
  $search.addClass("active");
  $searchTrigger.addClass("active");
  $searchInput.val("");
  $searchInput.trigger("focus");
  $pageHeader.addClass("search-header");
  reRenderSearch(filter);
};

const hideSearch = (filter, force = false) => {
  if ($search.hasClass("active")) {
    if (force === true) {
      $searchInput.val("");
    }
    if (!$searchInput.val()) {
      filter.page = 1;
      filter.search = $searchInput.val();
      reRenderSearch(filter);
      $search.removeClass("active");
      $searchTrigger.removeClass("active");
      $pageHeader.removeClass("search-header");
    }
    $searchTrigger.trigger("focus");
  }
};

const bindSearch = (filter) => {
  $searchInput.on(
    "input",
    debounce(function () {
      filter.search = $searchInput.val();
      reRenderSearch(filter);
    })
  );
  $searchForm.on("change", "input:checkbox:checked", function () {
    const $thisEl = $(this);
    filter.type.push($thisEl.val());
    reRenderSearch(filter);
  });
  $searchForm.on("change", "input:checkbox:not(:checked)", function () {
    const $thisEl = $(this);
    filter.type = $.grep(filter.type, function (n) {
      return n != $thisEl.val();
    });
    reRenderSearch(filter);
  });
};

const reRenderSearch = async (filter) => {
  const data = await getSearchItems(filter);
  $searchContent.html(data.html);
  $searchContent.addClass("search__content--active");
  debounce(restrictSearchContent());
};

const getSearchItems = async (filter) => {
  try {
    const response = await fetch(
      SITE_PARAMS.site_url + "/wp-json/mendelu/v1/search/html",
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
        }),
        body: JSON.stringify(filter),
      }
    );
    const result = await response.json();
    return result;
  } catch (e) {
    console.log(e);
    return null;
  }
};

const restrictSearchContent = () => {
  $searchContent.css(
    "max-height",
    `${Math.floor(100 * getVh() - $searchContent.offset().top - 50)}px`
  );
};

/* ------------------------------------------------------ */

const filter = {
  page: 1,
  search: $searchInput.val(),
  type: [],
  lang: $search.data("lang"),
};

restrictSearchContent();
$window.on("resize", debounce(restrictSearchContent, false, 500));
$pageBody.on("scroll", debounce(restrictSearchContent, false, 500));

$window.on(
  "resize:width",
  debounce(function () {
    hideSearch(filter);
  }, true)
);

$searchTrigger.on("click", function (event) {
  event.stopPropagation();
  toggleSearch(filter);
});
$searchWrapper.on("click", function (event) {
  event.stopPropagation();
});
$body.on("click", function () {
  hideSearch(filter);
});
$hamburger.on("click", function () {
  hideSearch(filter, true);
});
$searchClose.on("click", function () {
  hideSearch(filter, true);
});
$searchClose.on("keydown", function (e) {
  if (e.shiftKey && e.key === "Tab") {
    console.log("s");
    e.preventDefault();
    $searchInput.trigger("focus");
  } else if (e.key === "Tab") {
    e.preventDefault();
    $searchInput.trigger("focus");
    // hideSearch(filter, true);
  }
});
$searchInput.on("keydown", function (e) {
  if (e.shiftKey && e.key === "Tab") {
    e.preventDefault();
    hideSearch(filter, true);
  }
});

$window.on("keydown", function (e) {
  if ($search.hasClass("active")) {
    if (e.key === "Escape") {
      hideSearch(filter, true);
    }
  }
});
bindSearch(filter);

// accessibility search__content

$searchInput.on("keydown", function (e) {
  const $searchItems = $("ul.search__items");
  const $searchItem = $searchItems.find("li.search-item");
  if (e.keyCode == 40) {
    $searchItems.trigger("focus");
    $searchItem.first().trigger("focus");
  }
});

$searchContent.on("keydown", "li.search-item", function (e) {
  const $this = $(this);
  if (e.keyCode == 40) {
    $this.next().focus();
    return false;
  } else if (e.keyCode == 38) {
    if ($this.is(":first-child")) {
      $this.on("keydown", function (e) {
        if (e.keyCode == 38) {
          $searchInput.trigger("focus");
          return false;
        } else if (e.shiftKey && e.key === "Tab") {
          $searchInput.trigger("focus");
          return false;
        }
      });
    } else if ($this.not(":first-child")) {
      $this.prev().focus();
    }
    return false;
  }
});

$searchContent.on("keydown", "button.search__more", function (e) {
  if (e.shiftKey && e.key === "Tab") {
    $("input.checkbox-search__control").last().trigger("focus");
    return false;
  } else if (e.key === "Tab") {
    // $searchInput.trigger("focus");
    $searchClose.trigger("focus");
    return false;
  }
});

const $document = $(document);

$document.ready(function () {
  const $searchPageInput = $("input.input__control");
  $searchPageInput.trigger("focus");
});

// ============================= Search page ===================

const $searchPageForm = $(".search-page .search__form");

$(document).ready(function () {
  $searchPageForm.on("change", "input:checkbox", function () {
    $searchPageForm.submit();
  });
});
